export default {
  // 获取用户时区+8  +8.5 +10.75 -5
  timeZone () {
    let timezone = new Date().getTimezoneOffset() / 60
    // let mins = (new Date().getTimezoneOffset() / 60 - parseInt(timezone)) * 60
    let zone = -timezone > 0 ? '+' + String(-timezone) : -timezone
    return zone
  },
  globetime () {
    let timezone = new Date().getTimezoneOffset() / 60
    let mins = (new Date().getTimezoneOffset() / 60 - parseInt(timezone)) * 60
    let zone = -timezone > 0 ? '+' + -parseInt(timezone) + ':' + (-mins > 0 ? -mins : '00') : -parseInt(timezone) + ':' + (-mins > 0 ? -mins : '00')
    return zone
  },
  getTimeZoneCity () {
    var timezone = jstz.determine()
    return timezone.name()
  },
  // 2020-06-27T14:20:27.000000Z 时间格式转换成 2020-06-27 14:20:27
  rTime (date) {
    var json_date = new Date(date).toJSON()
    return new Date(new Date(json_date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
  },
  // time是utc时间2021-06-10T18:37:45.000000Z，timeZone是时区
  // getTimeByTimeZone (time, timeZone) {
  //   var d = new Date()
  //   var localOffset = d.getTimezoneOffset() * 60000// 获得当地时间偏移的毫秒数,这里可能是负数
  //   var utc = new Date(time).getTime() + localOffset // utc即GMT时间 转成时间戳
  //   var offset = timeZone // 时区+8  +8.5 +10.75 -5
  //   var localSecondTime = utc + (3600000 * offset) // 本地对应的毫秒数
  //   var date = new Date(localSecondTime)
  //   console.log('根据本地时间得知' + timeZone + '时区的时间是 ' + date.toLocaleString())
  //   console.log('系统默认展示时间方式是：' + date)
  //   console.log('格式化之后的时间：' + this.rTime(date))
  //   return this.rTime(date)
  // },
  // time是utc时间18:37:45,timeZone是时区
  // getHourByHourZone (time, timeZone) {
  //   var time = Number(time.split(':')[0]) * 60 * 60 * 1000 + Number(time.split(':')[1]) * 60 * 1000 + Number(time.split(':')[2]) * 1000
  //   var offset = timeZone // 时区+8  +8.5 +10.75 -5
  //   var localSecondTime = time + (3600000 * offset) // 本地对应的毫秒数
  //   var date = new Date(localSecondTime)
  //   // console.log('根据本地时间得知' + timeZone + '时区的时间是 ' + date.toLocaleString())
  //   // console.log('系统默认展示时间方式是：' + date)
  //   // console.log('格式化之后的时间：' + this.rTime(date))
  //   return this.rTime(date)
  // },
  // 更新时间戳转日期 yyyy-MM-dd hh:mm:ss
  formatDateTime (stemp) {
    var date = this.getTimeByTimeZone(stemp, 8)
    var y = date.getFullYear()
    var m = date.getMonth() + 1
    m = m < 10 ? ('0' + m) : m
    var d = date.getDate()
    d = d < 10 ? ('0' + d) : d
    var h = date.getHours()
    h = h < 10 ? ('0' + h) : h
    var minute = date.getMinutes()
    var second = date.getSeconds()
    minute = minute < 10 ? ('0' + minute) : minute
    second = second < 10 ? ('0' + second) : second
    return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
  },
  /**
   * 金额千位分隔
   * @param {num} num 2999
   * @returns 2,999.00
   */
  numFormat (num) {
    let price = Number(num)
      .toFixed(2)
      .toString()
      .replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,')
      // var c = (num.toString().indexOf ('.') !== -1) ? num.toLocaleString() : num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    return price
  },
  /**
   * 日期转换格式
   * @param {date} date 2021-06-02 21:28:47或者Fri Jun 11 2021 02:37:45 GMT+0800 (中国标准时间)
   * @returns 2021/6/2
   */
  setDate (date) {
    var date = new Date(date)
    return date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate()
  },
  /**
   * 日期转换星期
   * @param {date} date 2021-06-02 21:28:47
   * @returns Sunday
   */
  setDateToWeek (date) {
    var date = new Date(date), week
    if (date.getDay() == 0) week = 'Sunday'
    if (date.getDay() == 1) week = 'Monday'
    if (date.getDay() == 2) week = 'Tuesday'
    if (date.getDay() == 3) week = 'Wednesday'
    if (date.getDay() == 4) week = 'Thursday'
    if (date.getDay() == 5) week = 'Friday'
    if (date.getDay() == 6) week = 'Saturday'
    return week
  },
  formatDate (time) {
    var date = new Date(time.replace(/-/g, '/'))
    return date
  },
  /**
  * 判断是否是今天
  * @param {date} date 2021-06-02 21:28:47
  * @returns true/false
  */
  // isToday (date) {
  //   var str = new Date()
  //   return this.rTime(str).toString().substr(0, 10) === date.toString().substr(0, 10)
  // },
  /**
  * 时间转换成英文月份
  * @param {date} date 2021-06-02 21:28:47
  * @returns 2021 March 3 / March 3
  */
  setEnMonthTime (date, year) {
    var d = new Date(date)
    if (year) {
      var resDate = d.getFullYear() + ' ' + this.Month_En(d.getMonth() + 1) + ' ' + d.getDate()
      // var resTime = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
      return resDate
    } else {
      var resDate = this.Month_En(d.getMonth() + 1) + ' ' + d.getDate()
      // var resTime = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
      return resDate
    }
  },

  /**
  * 时间转换成am/pm
  * @param {date} date 2021-06-02 21:28:47
  * @returns 09:00am / 02:00pm
  */
  setAMPMTime (date) {
    var d = new Date(date)
    // if (year) {
    var M = d.getMinutes() < 10 ? ('0' + d.getMinutes()) : d.getMinutes()
    var resTime = (d.getHours() > 12 ? d.getHours() - 12 : d.getHours()) + ':' + M + (d.toLocaleTimeString().indexOf('上午') > -1 ? 'am' : 'pm')
    return resTime
    // } else {
    //   // var resDate = this.Month_En(d.getMonth() + 1) + ' ' + d.getDate()
    //   var resTime = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
    //   return resTime
    // }
  },

  /**
  * 时间转换成星期
  * @param {date} date 2021-06-02 21:28:47
  * @returns 123
  */
  setAMPMWeek (date, week) {
    var d = new Date(date)
    // if (year) {
    var M = d.getMinutes() < 10 ? ('0' + d.getMinutes()) : d.getMinutes()
    var resTime = (d.getHours() > 12 ? d.getHours() - 12 : d.getHours()) + ':' + M + (d.toLocaleTimeString().indexOf('上午') > -1 ? 'am' : 'pm')
    if (this.timeZone() < 0 && Math.abs(this.timeZone()) < d.getHours()) {
      week = Number(week) - 1
    } else if (this.timeZone() > 0 && Math.abs(this.timeZone()) < 24 - d.getHours()) {
      week = Number(week) + 1
    }
    return this.setWeek(week.toString()) + ' - ' + resTime
    // } else {
    //   // var resDate = this.Month_En(d.getMonth() + 1) + ' ' + d.getDate()
    //   var resTime = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
    //   return resTime
    // }
  },
  /**
  * 月份成英文月份
  * @param {date} date 1/2/3/4/5/6/7/8/9/10/11/12
  * @returns March
  */
  Month_En (num) {
    switch (num) {
      case 12:
        return 'December'
        break
      case 11:
        return 'November'
        break
      case 10:
        return 'October'
        break
      case 9:
        return 'September'
        break
      case 8:
        return 'August'
        break
      case 7:
        return 'July'
        break
      case 6:
        return 'June'
        break
      case 5:
        return 'May'
        break
      case 4:
        return 'April'
        break
      case 3:
        return 'March'
        break
      case 2:
        return 'February'
        break
      case 1:
        return 'January'
        break
      default:
        return ''
    }
  },
  /**
 * 数字转换英文
 * @param {date} num 1/2/3/4/5/6/7
 * @returns Sunday
 */
  setWeek (num) {
    switch (num) {
      case '7':
        return 'Sunday'
        break
      case '6':
        return 'Saturday'
        break
      case '5':
        return 'Friday'
        break
      case '4':
        return 'Thursday'
        break
      case '3':
        return 'Wednesday'
        break
      case '2':
        return 'Tuesday'
        break
      case '1':
        return 'Monday'
        break
      default:
        return ''
    }
  },
  setCookies (obj, limitTime) {
    for (let i in obj) {
      document.cookie = i + '=' + obj[i]
    }
  },
  getCookie (name) {
    var arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'))
    if (arr != null) {
      return unescape(arr[2])
    } else {
      return null
    }
  },
  clearCookie (name) {
    let json = {}
    json[name] = ''
    this.setCookies(json, -1)
  },
  getToday () {
    const date = new Date(new Date().getTime())
    // 获取年、月、日
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0') // 月份从0开始，所以要加1
    const day = String(date.getDate()).padStart(2, '0')
    // 组合成 "YYYY-MM-DD" 格式
    return `${year}-${month}-${day}`
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js